import React from 'react';
import ProductsScreenView from './ProductsScreenview';
import { ProductsContextProvider } from '../../context/ProductsContext';

const ProductsView = () => {
    return (
        <ProductsContextProvider>
            <ProductsScreenView />
        </ProductsContextProvider>
    );
};

export default ProductsView;
